import "./App.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { GlobalUserProvider } from "./context/user.context";
import { DataProvider } from "./context/DataContext";

function App() {
  return (
    <GlobalUserProvider>
      <DataProvider>
        <RouterProvider router={router} />
      </DataProvider>
    </GlobalUserProvider>
  );
}

export default App;
